import { v4 as uuidv4 } from 'uuid'

import GalleryOne from 'assets/images/gallery/galleryOne.jpg'
import GalleryTwo from 'assets/images/gallery/galleryTwo.jpg'
import GalleryThree from 'assets/images/gallery/galleryThree.jpg'
import GalleryFour from 'assets/images/gallery/galleryFour.jpg'
import GalleryFive from 'assets/images/gallery/galleryFive.jpg'
import GallerySix from 'assets/images/gallery/gallerySix.jpg'
import GallerySeven from 'assets/images/gallery/gallerySeven.jpg'
import GalleryEight from 'assets/images/gallery/galleryEight.jpg'

const galleryData = [
  {
    id: uuidv4(),
    url: GalleryOne,
  },
  {
    id: uuidv4(),
    url: GalleryTwo,
  },
  {
    id: uuidv4(),
    url: GalleryThree,
  },
  {
    id: uuidv4(),
    url: GalleryFour,
  },
  {
    id: uuidv4(),
    url: GalleryFive,
  },
  {
    id: uuidv4(),
    url: GallerySix,
  },
  {
    id: uuidv4(),
    url: GallerySeven,
  },
  {
    id: uuidv4(),
    url: GalleryEight,
  },
]

export default galleryData
